export const crudMessage = {
	create: {
		title: "Nuevo mensaje",
		subtitle: {
			sms:
				"Ingrese el contenido que se enviará a la lista de clientes seleccionada. Su mensaje impactará a ",
			whatsapp:
				"Seleccione una plantilla según lo que desea comunicar y luego modifique sus parámetros.",
		},
		client: "persona",
		clients: "personas",
		show: "Haga clic aquí para ver consejos sobre el contenido",
		subtitleTemplateList:
			"Seleccione una plantilla según lo que desea comunicar y luego modifique sus parámetros.",
	},
	edit: {
		title: "Editar mensaje programado",
		subtitle: "Reescriba el contenido del mensaje o modifique la programación del envío.",
	},
	resume: "Datos del envío",
	content: "Contenido del mensaje",
	program: "Programar envío",
	sendNow: "Enviar ahora",
	textArea: {
		content: "Contenido del mensaje",
		copy: "Copiar contenido del mensaje",
		sucessCopy: "Mensaje copiado al portapapeles",
		at: "a las",
		placeholder: "Escriba el contenido del mensaje para el grupo seleccionado...",
		character: "carácter restante",
		characters: "caracteres restantes",
		footer:
			"Consejo: para agregar variables y poder modificarlas en el futuro, escriba [VARIABLE] entre corchetes.",
	},
	resumeCard: {
		sms: "SMS",
		footerText: {
			summarizes: "Los mensajes para clientes con optout no serán cobrados.",
			smsBalanceAddedValue:
				"El valor extra de {{value}} se agregará al pago del cobro mensual de Zig.",
			smsBalanceSubtractedValue:
				"El valor de {{value}} se descontará del pago del cobro mensual de Zig.",
			noExtraCost:
				"Como no hubo cambios en la cantidad de la lista de destinatarios, no habrá ningún costo extra.",
			charactersLimit:
				"La cantidad de caracteres superó el límite. El costo del SMS fue modificado y el valor de {{value}} se agregará al pago del cobro mensual de Zig.",
			addedValue: "El valor de {{value}} se agregará al pago del cobro mensual de Zig.",
		},
		messageCost: "Costo del envío",
		amountMessageSent: "Total de destinatarios",
		summarizes: "Resumen del envío",
		messageInProcess: {
			sms: "SMS en procesamiento",
			whatsapp: "Mensaje en procesamiento",
		},
		amountMessageReceived: {
			sms: "SMS recibidos",
			whatsapp: "mensajes recibidos",
		},
		amountMessageNotReceived: {
			notRecieved: {
				sms: "SMS no recibidos",
				whatsapp: "mensajes no recibidos",
			},
			optout: {
				sms: "SMS no recibidos por optout",
				whatsapp: "mensajes no recibidos por optout",
			},
			error: {
				sms: "SMS no recibidos por error",
				whatsapp: "mensajes no recibidos por error",
			},
		},
		resume: "Resumen del envío",
		rescheduledShippingCost: "Costo del envío reprogramado",
		postShipmentBalance: "Saldo después del envío",
	},
	modalMessage: {
		title: {
			messageSent: "Mensaje enviado",
			messageScheduled: "Mensaje programado",
			messageTips: "Consejos de mensaje",
		},
		messageScheduled: {
			clientsCount: "Su mensaje será enviado a ",
			client: "cliente",
			clients: "clientes",
			of: "de",
			day: "día",
			at: "a las",
			cancelOrEdit:
				"Si desea cancelar el envío o modificar el contenido, vuelva a la lista de mensajes y edite la información de envío.",
		},
		messageSent: {
			clientsCount: "Su mensaje fue enviado a ",
			client: "cliente",
			clients: "clientes",
			of: "de",
		},
		messageTips: {
			tips: "Consejos de lo que puede hacer",
			tipOne:
				"¡Un mensaje bien escrito impacta a sus clientes de manera única! Como tiene {{characters}} caracteres, lo ideal es que su mensaje sea conciso, claro y directo.",
			tipTwo:
				"Puede incluir enlaces importantes para sus clientes. Enlaces a su landing page o al ticket del evento facilitan el acceso del cliente a la información y compra de entradas.",
			tipThree:
				"¿Va a lanzar una promoción interesante? Filtre el grupo de clientes que tiene derecho a la promoción y envíe SMS dirigido.",
			tipFour:
				"¿Lanzamiento de algún producto nuevo? Filtre a sus mejores clientes y envíe toda la información de su producto.",
		},
		addBalance: "Agregar Saldo",
		notBalance:
			"No tiene saldo suficiente para enviar SMS al grupo seleccionado. ¿Desea agregar el saldo restante?",
	},
	campaignSelect: {
		title: "Campaña",
		placeholder: "Seleccionar campaña",
		createOrSearch: "Busque por campaña o cree una nueva",
		text:
			"OPCIONAL: Vincule este envío a una campaña para facilitar el análisis del rendimiento de múltiples envíos juntos.",
	},
	campaignModal: {
		title: "Nombre de la campaña",
		tooltipMessage:
			"OPCIONAL: Vincule este envío a una campaña para facilitar el análisis del rendimiento de múltiples envíos juntos.",
		placeholder: "Ingrese el nombre de la campaña",
		confirmButton: "Crear campaña",
	},
	campaignsDetail: {
		columns: {
			clientName: "Nombre del cliente",
			gender: "Género",
			cpf: "CPF",
			status: "Estado",
			phone: "Teléfono",
		},
		genders: {
			male: "Hombre",
			female: "Mujer",
			other: "Otro",
			uninformed: "No informado",
		},
		sent: "Enviado",
		canceled: "Cancelado",
		sentInDay: "Enviado el día {{day}} a",
		clients: "clientes",
		client: "cliente",
		programedMessage:
			"Su mensaje fue programado el día {{day}} para ser enviado el día {{date}}",
		canceledMessage: "El mensaje que sería enviado el día {{day}} fue cancelado",
	},
	day: "Día",
	hour: "Hora",
	footer: {
		reprogram: "Reprogramar envío de SMS",
		scheduleShipping: "Programar envío de SMS",
		send: "Enviar SMS ahora",
	},
	success: {
		createTemplate: "Nueva plantilla solicitada",
	},
	errors: {
		smsCost: "El costo del SMS debe ser configurado",
		place: "No fue posible identificar el local",
		campaign: "No fue posible crear la campaña.",
		editMessage: {
			sendNow: "Datos actualizados. El mensaje será enviado en breve.",
			sucess: "Datos actualizados.",
		},
	},
};
